<template>
  <div class="publicityDetail1">    
    <h3>【守住钱袋子护好幸福家】防范非法集资，这些常识，您一定要知道</h3>
    <div class="title">什么是非法集资</div>
    <p>根据《防范和处置非法集资条例》，非法集资是指未经国务院金融管理部门依法许可或者违反国家金融管理规定，以许诺还本付息或者给予其他投资回报等方式，向不特定对象吸收资金的行为。</p>
    <img :src="require('../images/ic_publicity_detail1_1.png')"/>
    <div class="title">非法集资常见手段</div>
    <div class="subtitle">01 承诺高额回报</div>
    <img :src="require('../images/ic_publicity_detail1_2.png')"/>
    <p>不法分子编造“天上掉馅饼”“一夜成富翁”的神话，许诺投资者高额回报。为了骗取更多的人参与集资，非法集资人在集资初期往往按时足额兑现承诺本息，待集资达到一定规模后，便秘密转移资金或携款潜逃，使集资参与人遭受经济损失。</p>
    <div class="subtitle">02 编造虚假项目</div>
    <img :src="require('../images/ic_publicity_detail1_3.png')"/>
    <p>不法分子大多通过注册合法的公司或企业，打着响应国家产业政策、开展创业创新等幌子，编造各种虚假项目，有的甚至组织免费旅游、考察等，骗取社会公众信任。</p>
    <div class="subtitle">03 以虚假宣传造势</div>
    <img :src="require('../images/ic_publicity_detail1_4.png')"/>
    <p>不法分子在宣传上往往一掷千金，聘请明星代言、名人站台，在各大广播电视、网络等媒体发布广告、在著名报刊上刊登专访文章、雇人广为散发宣传单、进行社会捐赠等方式，制造虚假声势。</p>
    <div class="subtitle">04 利用亲情诱骗</div>
    <img :src="require('../images/ic_publicity_detail1_5.png')"/>
    <p>有些类传销非法集资的参与人，为了完成或增加自己的业绩，不惜利用亲情、血缘关系，编造自己获得高额回报的谎言，拉拢亲朋、同学或邻居加入，使参与人员迅速蔓延，集资规模不断扩大。</p>
    <div class="title">典型非法集资活动“四部曲”</div>
    <p>第一步：画饼。非法集资人会编织一个或多个尽可能“高大上”的项目。以“新技术”、“新革命”、“新政策”、“区块链”、“虚拟货币”等为幌子，描绘一幅预期报酬丰厚的蓝图，把集资参与人的胃口“吊”起来，让其产生“不容错过”“机不可失”的错觉。非法集资人一般会把“饼”画大，尽可能吸引参与人眼球。</p>
    <p>第二步：造势。利用一切资源把声势做大。非法集资人通常会举办各种造势活动，比如新闻发布会、产品推介会、现场观摩会、体验日活动、知识讲座等；组织集体旅游、考察等，赠送米面油、话费等小礼品；大量展示各种或真或假的“技术认证”“获奖证书”“政府批文”；公布一些领导视察影视资料，公司领导与政府官员、明星合影；故意把活动选在政府会议中心、礼堂进行，其场面之大、规格之高极具欺骗性。</p>
    <p>第三步：吸金。想方设法套取你口袋里的钱。非法集资人通过返点、分红，给参与人初尝“甜头”，使其相信把钱放在他那儿不仅有可观的收入，而且比放在自己口袋里还安全，参与人不仅将自己的钱倾囊而出，还动员亲友加入，集资金额越滚越大。</p>
    <p>第四步：跑路。非法集资人往往会在“吸金”一段时间后跑路，或者因为原本就是“庞氏骗局”人去楼空，或者因为经营不善致使资金链断裂。集资参与人遭受惨重经济损失，甚至血本无归。</p>
    <div class="title">风险防范提示</div>
    <img :src="require('../images/ic_publicity_detail1_6.png')"/>
    <div class="subtitle no-indent">一.</div>
    <p>如遇以下情形向公众集资的，务必提高警惕</p>
    <p>①以“看广告、赚外快”“消费返利”为幌子的；</p>
    <p>②以境外投资股权、期权、外汇、贵金属等为幌子的；</p>
    <p>③以投资养老产业可获高额回报或“免费”养老、“以房”养老等为幌子的；</p>
    <p>④以私募入股、合伙办企业为幌子，但不办理企业工商注册登记的；</p>
    <p>⑤以投资虚拟货币、区块链等为幌子的；</p>
    <p>⑥以“扶贫”“互助”“慈善”“影视文化”等为幌子的；</p>
    <p>⑦在街头、商场、超市等发放投资理财等内容广告传单的；</p>
    <p>⑧以组织考察、旅游、讲座等方式招揽老年群众的；</p>
    <p>⑨“投资、理财”公司、网站及服务器在境外的；</p>
    <p>⑩要求以现金方式或向个人账户、境外账户缴纳投资款的；</p>
    <div class="subtitle no-indent">二.</div>
    <p>防范非法集资的“四看三思等一夜”法</p>
    <p>四看。一看融资合法性，除了看是否取得企业营业执照，还要看是否取得相关金融牌照或经金融管理部门批准。二看宣传内容，看宣传中是否含有或暗示“有担保、无风险、高收益、稳赚不赔”等内容。三看经营模式，有没有实体项目，项目真实性、资金的投向去向、获取利润的方式等。四看参与集资主体，是不是主要面向老年人等特定群体。</p>
    <p>三思。一思自己是否真正了解该产品及市场行情。二思产品是否符合市场规律。三思自身经济实力是否具备抗风险能力。</p>
    <p>等一夜。遇到相关投资集资类宣传，一定要避免头脑发热，先征求家人和朋友的意见，拖延一晚再决定。不要盲目相信造势宣传、熟人介绍、专家推荐，不要被高利诱惑盲目投资。</p>
    <div class="subtitle no-indent">三.</div>
    <p>规避非法集资陷阱的“三要、三不要”</p>
    <p>①要理性，不要侥幸。天上不会掉馅饼，掉下来的不是“圈套”就是“陷阱”。要坚守理性底线，想想自己懂不懂，比比风险大不大，看看收益水平合不合实际，问问家人朋友怎么看，不要被赌博心态和侥幸心理蒙蔽双眼！</p>
    <p>②要稳健，不要冒险。高收益意味着高风险，还可能是投资骗局，投一次就血本无归！要合理评估自身承受能力，审慎确定风险承担意愿，不冒险投资！</p>
    <p>③要警惕，不要盲目。“收益丰厚、条件诱人、机会难得、名额有限”都很可能是忽悠，一定要警惕、警惕、再警惕！多留个心眼儿，绝不要听风就是雨，盲目“随大流”投资</p>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail1'
};
</script>

<style scoped lang="less">
.publicityDetail1 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 45px;
  }

  .subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: 500;
    text-indent: 2em;

    &.no-indent {
      text-indent: unset;
    }
  }

  div {
    text-align: left;
  }

  p {
    text-indent: 2em;
    margin: 15px 0 0;
    text-align: left;
    margin-block-end: 0;
    margin-block-start: 0;
  }

  img {
    width: 50%;
    margin-top: 30px;
    align-self: center;
  }

  p + img,
  .subtitle + img {
    margin-left: 2em;
  }

  img + p {
    margin-top: 15px;
  }

  img + .title,
  p + .title {
    margin-top: 60px;
  }

  .title + .subtitle,
  img + .subtitle {
    margin-top: 15px;
  }

  p + .subtitle {
    margin-top: 45px;
  }
}
</style>
